import {FullUser} from './full-user.model';
import {Position} from './position.model';

export class GroupUser {
  public user: FullUser;
  public position: Position;
  public isUserSelected: false;

  constructor(user: FullUser,
              position: Position) {
    this.user = user;
    this.position = position;
  }
}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/models/group-user.model.ts